import { Component, Vue } from "vue-property-decorator";

import { UserModel } from "@/models";

@Component<AdminUserEditController>({
  components: {}
})
export default class AdminUserEditController extends Vue {
  private form: object = {
    id: 0,
    account: "",
    password: "",
    name: "",
    role: ""
  };

  public async created() {
    const editData = await UserModel.getByID(parseInt(this.$route.params.id));

    this.assignDataToForm(editData);
  }

  private assignDataToForm(data: unknown) {
    const item = data as { [key: string]: unknown };

    this.$data.form.id = item.id;
    this.$data.form.account = item.account;
    this.$data.form.password = item.password;
    this.$data.form.name = item.name;
    this.$data.form.role = item.role;
  }

  private resetForm() {
    this.$data.isEdit = false;

    this.$data.form.id = 0;
    this.$data.form.account = "";
    this.$data.form.password = "";
    this.$data.form.name = "";
    this.$data.form.role = "";
  }

  private async submitForm() {
    const postData = JSON.parse(JSON.stringify(this.$data.form));

    const errNo = await UserModel.edit(this.$data.form.id, postData);
    if (errNo === 1) {
      window.location.href = "/admin/user";
    }
  }
}
